import { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOMServer from 'react-dom/server';

export class InfoWindow extends Component {
  componentDidMount() {
    this.renderInfoWindow();
    if (this.props.visible) {
      this.openWindow();
    }
  }

  componentDidUpdate(prevProps) {
    const google = window.google;
    const { map } = this.props;

    if (!google || !map) {
      return;
    }

    if (map !== prevProps.map) {
      this.renderInfoWindow();
    }

    if (this.props.children !== prevProps.children) {
      this.updateContent();
    }

    if (this.props.visible !== prevProps.visible || this.props.marker !== prevProps.marker) {
      if (this.props.visible) {
        this.openWindow();
      } else {
        this.closeWindow();
      }
    }
  }

  onOpen() {
    if (this.props.onOpen) {
      this.props.onOpen();
    }
  }

  onClose() {
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  openWindow() {
    this.infowindow.open(this.props.map, this.props.marker);
  }

  updateContent() {
    const content = this.renderChildren();
    this.infowindow.setContent(content);
  }

  closeWindow() {
    this.infowindow.close();
  }

  renderInfoWindow() {
    const google = window.google;

    if (!google || !google.maps) {
      return;
    }

    const iw = (this.infowindow = new google.maps.InfoWindow({
      content: this.renderChildren(),
    }));

    google.maps.event.addListener(iw, 'closeclick', this.onClose.bind(this));
    google.maps.event.addListener(iw, 'domready', this.onOpen.bind(this));
  }

  renderChildren() {
    const { children } = this.props;
    return ReactDOMServer.renderToString(children);
  }

  render() {
    return null;
  }
}

InfoWindow.propTypes = {
  children: PropTypes.element.isRequired,
  /* eslint-disable react/forbid-prop-types */
  map: PropTypes.object,
  marker: PropTypes.object,
  /* eslint-enable react/forbid-prop-types */
  visible: PropTypes.bool,

  // callbacks
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
};

InfoWindow.defaultProps = {
  visible: false,
};

export default InfoWindow;
